import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import registerNamespace from './locales';
import StyledAvatar from './styled/Avatar.styled';

const namespace = registerNamespace('src/juristec-ui/core/Avatar/Avatar.jsx');

/**
* Avatar is an object that represents the user's identity on screen. If there is no picture associated with the user, it renders the user name initials.
*/
const Avatar = ({
  name = '', size = 'medium', src = '', ...props
}) => {
  const { t } = useTranslation(namespace);
  const showname = !name || name.length === 0 ? [t('myself')] : name.match(/([a-z0-9]+)/ig) || '';
  return (
    <>
      <StyledAvatar size={size} src={src || null} style={props.style} onClick={props.onClick} {...props}>
        {!src
          && (showname.length > 1
            ? showname
              .filter((item, idx, ar) => idx === 0 || idx === ar.length - 1)
              .map((item) => item[0])
            : showname[0].slice(0, 2))}
      </StyledAvatar>
    </>
  );
};

Avatar.propTypes = {
  /**
   * String that represents the name of the user.
   */
  name: PropTypes.string,
  /**
   * Size of the avatar. Choose from four different options.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large', 'extralarge', 'profile']),
  /**
   * An optional url to the user image.
   */
  src: PropTypes.string,
};

export default memo(Avatar);
